<script lang="ts">
	import { getColorForString } from '../../../../helper/Colors';
	import { transformHTMLToString } from '../../../../pdf/TransformFunctions';
	import { systemPositionTypeStore } from '../../../../stores/ClientStore';
	import type { PositionCataloguePosition } from '../../../../types/CataloguesTypes';
	import { getLabelForSystemPositionType, rowTypes } from '../../../../types/DocumentTypes';
	import { ViewMode } from '../../../../types/ListTypes';
	import { type SearchPositionCataloguePositionStore } from '../search/SearchPositionCataloguePositionStore.svelte';
	import ListItemVariant from './ListItemVariant.svelte';

	interface Props {
		store: SearchPositionCataloguePositionStore;
		item: PositionCataloguePosition;
		index: number;
		viewMode: ViewMode;
		onCustomEvent: (info: any) => void;
	}

	let { store, item, index, viewMode, onCustomEvent }: Props = $props();

	let showVariants: boolean = $state(false);
	let hoverText = $derived(transformHTMLToString(item.name));

	function handlePosClick() {
		//If we have more than one variant we are going to show the variants
		if (item.costVariants.length > 1) {
			showVariants = !showVariants;
		} else {
			//We are directly adding the position

			let variant = item.costVariants[0];

			onCustomEvent({
				targetPos: item,
				variant: variant
			});
		}
	}
</script>

<div class="bg-white dark:bg-dark-400 rounded-[5px] text-sm">
	<!--Pos Title information-->
	{#if item.fkSystemRowType == rowTypes.title}
		<div class="flex">
			<div
				class="w-2 rounded-bl-md"
				style="background-color: {getColorForString(item.fkPositionCatalogue.toString())};"
			></div>
			<button
				onclick={(_) => {
					onCustomEvent({
						targetPos: item,
						variant: null
					});
				}}
				class="text-left bg-primary-200 grid grid-cols-[auto_1fr] gap-2 text-white rounded-br-md p-2 w-full"
			>
				<p class="truncate">
					{item.positionNr || ''}
				</p>
				<p class="truncate" title={item.shortName}>
					{item.shortName || ''}
				</p>
			</button>
		</div>
	{:else if item.fkSystemRowType == rowTypes.text}
		<!--Text-->
		<div class="flex">
			<div
				class="w-2 rounded-bl-md"
				style="background-color: {getColorForString(item.fkPositionCatalogue.toString())};"
			></div>
			<button
				onclick={(_) => {
					onCustomEvent({
						targetPos: item,
						variant: null
					});
				}}
				class="text-left bg-primary-300 grid grid-cols-[auto_1fr] gap-2 text-white rounded-br-md p-2 w-full"
			>
				<p class="truncate">
					{item.positionNr || ''}
				</p>
				<p class="truncate" title={item.shortName}>
					{item.shortName || ''}
				</p>
			</button>
		</div>
	{:else}
		<!--Cost position-->
		<div class="flex text-white">
			<div
				class="w-2 rounded-bl-md"
				style="background-color: {getColorForString(item.fkPositionCatalogue.toString())};"
			></div>
			<button class="text-left bg-primary-300 w-full p-2" onclick={handlePosClick}>
				{#if viewMode == ViewMode.BIG}
					<p class="truncate">
						{item.positionNr || ''}
					</p>
					<div class="grid grid-cols-[1fr_auto] gap-2">
						<p class="truncate" title={item.shortName}>
							{item.shortName || ''}
						</p>

						<p class="">
							{getLabelForSystemPositionType(
								item.fkSystemPositionType,
								$systemPositionTypeStore,
								false
							)}
						</p>
					</div>
				{:else}
					<div class="grid grid-cols-[1fr_3fr_auto] gap-2">
						<p class="truncate">
							{item.positionNr || ''}
						</p>
						<p class="truncate" title={item.shortName}>
							{item.shortName || ''}
						</p>
					</div>
				{/if}
			</button>
			<button
				onclick={(e) => {
					//We have to stop the propagtion otherwise the item is already added
					e.stopPropagation();
					//Show the variants
					showVariants = !showVariants;
				}}
				class="text-xs px-2 py-1 bg-secondary-200 dark:bg-secondary-500 rounded-br-md"
			>
				{item.costVariants.length}
			</button>
		</div>

		<!--Text-->
		{#if viewMode == ViewMode.BIG}
			<p class="p-2">
				{hoverText}
			</p>
		{/if}

		<!--List of variants-->
		{#if showVariants}
			<div class="p-2 flex flex-wrap gap-2 items-center">
				{#each item.costVariants as variant}
					<ListItemVariant
						{store}
						{variant}
						onClick={(_) => {
							onCustomEvent({
								targetPos: item,
								variant: variant
							});
						}}
					/>
				{/each}
			</div>
		{/if}
	{/if}
</div>
